export const hasUserIdentity = (user) =>
  Boolean(user && typeof user === "object" && (user.id || user._id));

export const isAuthenticatedUserSession = (session) =>
  session?.authenticated === true &&
  session?.authType === "user" &&
  hasUserIdentity(session?.user);

export const getUserGateRoute = (user, gates = {}) => {
  if (!hasUserIdentity(user)) return "";
  if (gates.paymentRequired) return "/pagamento";
  if (gates.banned || user.banned) return "/banido";
  if (gates.renewalRequired) return "/renovacao";
  return "";
};

export const getSessionGateRoute = (session) => {
  if (!isAuthenticatedUserSession(session)) return "";
  return getUserGateRoute(session.user, session.gates);
};
